<template>
	<div class="panel_sale">
		<div class="list" v-if="type==='list'">
			<zhuyuanList></zhuyuanList>
		</div>
		<div class="add" v-if="type==='edit'">
			<zhuyuanEdit></zhuyuanEdit>
		</div>
		<div class="add" v-if="type==='see'">
			<zhuyuanSee></zhuyuanSee>
		</div>
	</div>
</template>
<script>
	import zhuyuanList from "../comp/zhuyuan_list.vue"
	import zhuyuanEdit from "../comp/zhuyuan_edit.vue"
	import zhuyuanSee from "../comp/zhuyuan_see.vue"
	export default {
		components:{zhuyuanList,zhuyuanEdit,zhuyuanSee},
		data(){
			return{
				
			}
		},
		computed:{
			type(){
				return this.$store.state.yiliaoxin.zhuyuanParams.type;
			}
		},
		mounted(){
			
		},
		methods: {
			
		},
	}
</script>
<style scoped lang="scss">
.panel_sale{
	width:100%;
	height: calc(100% - 145px);margin-top:12px;
	.list{
		height: 100%;
	}
	.add{
		height: 100%;
	}
}
</style>
